"use client"

import React from "react"
import { Slot } from "@radix-ui/react-slot"
import TC_Wrapper from "react-tag-commander"

import { transformButtonStyle } from "@/lib/utils"
import { Link, TButton, Typography } from "@/components/ui/atoms"

interface IVideoProps {
  asChild?: boolean
  title: string
  description?: string
  legend?: string
  video: string
  button?: TButton
  isAncrable?: boolean
}
const Video = React.forwardRef<HTMLDivElement, IVideoProps>(
  (
    {
      asChild = false,
      isAncrable = false,
      title,
      description,
      video,
      legend,
      button,
      ...props
    },
    ref
  ) => {
    const Component = asChild ? Slot : "div"
    const wrapper = TC_Wrapper.getInstance()

    if (typeof window !== "undefined") {
      window.focus()
      window.addEventListener("blur", () => {
        setTimeout(() => {
          if (document.activeElement?.tagName === "IFRAME") {
            wrapper.triggerEvent("action", undefined, {
              click: description,
              click_chapter1: title,
            })
          }
        })
      })
    }

    return (
      <Component className="bg-neutral-200 py-12" ref={ref} {...props}>
        <div className="container text-center">
          <div className="pb-10 lg:pb-12">
            <Typography variant="headingL" as="h2">
              {title}
            </Typography>
            {description ? (
              <Typography variant="paragraphM" className="pt-7">
                {description}
              </Typography>
            ) : null}
          </div>
          <div className="pb-10 lg:pb-12">
            <div
              className="flowplayer-embed-container"
              style={{
                position: "relative",
                paddingBottom: "56.25%",
                height: "0",
                overflow: "hidden",
                maxWidth: "100%",
              }}
            >
              <iframe
                allowFullScreen
                src={video}
                title="0"
                allow="autoplay"
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                }}
              ></iframe>
            </div>
          </div>
          {legend ? (
            <Typography variant="paragraphM" className="pb-6">
              {legend}
            </Typography>
          ) : null}
          {button ? (
            <div className="flex justify-center">
              <Link
                chapters={[title, button.ctaLabel]}
                className="lg:mx-3"
                title={title}
                variant={transformButtonStyle(button.style.toString())}
                iconLeft={button.iconLeft ?? undefined}
                iconRight={button.iconRight ?? undefined}
                href={button.ctaLink}
              >
                {button.ctaLabel}
              </Link>
            </div>
          ) : null}
        </div>
      </Component>
    )
  }
)
Video.displayName = "Video"

export { Video, type IVideoProps }
